import { theme } from "theme/create-theme";

export interface AllocationType {//TODO CC: this reeplace the old model from the API (//import { AllocationType } from '../../axiosApi/models';)
  name?: string | null;
  id?: number;
}

export const MIN_BEFORE_EXPIRATION = 5 * 60;

export const PIECOLORS = [
  theme.palette.divergent.a,
  theme.palette.divergent.b,
  theme.palette.divergent.c,
  theme.palette.divergent.d,
  theme.palette.divergent.e,
  theme.palette.divergent.f,
  theme.palette.divergent.g,
  theme.palette.divergent.h,
  theme.palette.divergent.i,
  theme.palette.divergent.j,
  theme.palette.divergent.k,
  theme.palette.divergent.l,
  theme.palette.divergent.m,
];

export const ACCESSIBLE_COLORS = [
  theme.palette.accessible.blue,
  theme.palette.accessible.orange,
  theme.palette.accessible.green,
  theme.palette.accessible.vermillion,
  theme.palette.accessible.skyBlue,
  theme.palette.accessible.reddishPurple,
  theme.palette.accessible.yellow,
  theme.palette.accessible.black,
];

export const ALLOCATION_TYPES:AllocationType[] = [{id:1, name:'%'  },{id:2, name: 'hours' }];
export const SORT_TYPES = {'ASC': 1, 'DESC': -1};

export enum USER_STATUS {
    ACTIVE = 1,
    INACTIVE = 2
}

export enum ENTITY_TYPE { // Not const because we need reverse lookup.
    ANY=0,
    EMPLOYEE=1,
    CLIENT=2,
    PROVIDER=3,
    CORPORATE_ENTITY=4
};
Object.freeze(ENTITY_TYPE); // We freeze it instead (so it's still immutable).

export const ENTITY_TYPE_NAMES: Record<number, string> = { // Because ENTITY_TYPE is a constant there is 
    [ENTITY_TYPE.ANY]: "ANY",
    [ENTITY_TYPE.EMPLOYEE]: "EMPLOYEE",
    [ENTITY_TYPE.CLIENT]: "CLIENT",
    [ENTITY_TYPE.PROVIDER]: "PROVIDER",
    [ENTITY_TYPE.CORPORATE_ENTITY]: "CORPORATE_ENTITY"
};

export type DateRange = {
    from: Date | undefined;
    to?: Date | undefined;
};

export const enum WORKFLOW_MODULES{
    COMPLETE_WORKFLOW = 1,
    TIME_OFF = 2,
    INVOICING = 3,
    ACCOUNTS_PAYABLE = 4
}

export const enum GLOBAL_DATE_CONFIG{
    WORKING_WEEK_DAYS = 7,
    WEEK_STARTS_ON = 1, // 0 = Sunday, 1 = Monday, etc.
}

export enum AppliesTo {
    All = 0,
    Invoice = 2,
    Item = 1
}

export enum SdsType {
    DISCOUNT = "discount",
    SHIPPING = "shipping",
    OTHER_CHARGES = "otherCharges"
}